import * as React from "react";

export class RestoreFocus extends React.Component {
    _prevActiveElement: HTMLElement;

    constructor(props: any, context: any) {
        super(props, context);
        this._prevActiveElement = document.activeElement as HTMLElement;
    }

    componentWillUnmount() {
        if (
            this._prevActiveElement &&
            this._prevActiveElement.focus &&
            document.body.contains(this._prevActiveElement)
        ) {
            this._prevActiveElement.focus();
        }
        this._prevActiveElement = null;
    }

    render() {
        return this.props.children || false;
    }
}
